import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  MatDialogRef,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Constant } from '../../constant';
import { Approver } from '../../model/my-event';
import { CommonUtil } from '../../util/common-util';
import { Auth } from '@aws-amplify/auth';
import { AuthService } from '../../auth/auth.service';
import { ToastUtil } from '../../util/toast-util';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'app-approver-select-dialog',
  templateUrl: './approver-select-dialog.component.html',
  styleUrl: './approver-select-dialog.component.css',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    MatCheckboxModule,
  ],
})
export class ApproverSelectDialogComponent implements OnInit {
  public readonly Constant = Constant;

  // 検索条件
  public selectedPosition: number | null = null;
  public lastName: string = '';
  public firstName: string = '';
  private apiPath = '/myevent/searchapprover';

  // 役職リスト
  public officialPositions = [];
  public showSpinner = true;
  private masters;
  private userId1;
  private userId2;
  private userId3;
  private extraExcludedIds: string[] = [];
  private eventId;
  private documentType;


  // 検索結果
  public searchResults: Approver[] = [];
  public isSearching = false;

  // 選択中の承認者
  public selectedApprovers: Approver[] = [];

  // 検索済みフラグ
  public hasSearched = false;
  public attendanceSearchError = '';

  constructor(
    public dialogRef: MatDialogRef<ApproverSelectDialogComponent>,
    private auth: AuthService,
    private commonUtil: CommonUtil,
    private toastUtil: ToastUtil,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    if (this.data?.attendanceMode === true) this.apiPath = '/myevent/attendance/setup';
    if (this.data?.operationManagerMode === true) this.apiPath = '/myevent/operations';
    // 初期状態では検索結果は空
    this.userId1 = this.data?.userId1;
    this.userId2 = this.data?.userId2;
    this.userId3 = this.data?.userId3;
    this.extraExcludedIds = this.data?.excludedUserIds ?? [];

    this.selectedApprovers = [
      ...(this.data?.selectedApprovers || [])
    ];

    this.eventId = this.data?.eventId;

    this.documentType = this.data?.documentType;

    this.getData();
  }

  // 検索実行（フォーカスが外れた時に実行）
  onSearch(force = false) {
    if (!this.data?.attendanceMode && !this.data?.operationManagerMode && !this.lastName && !this.firstName && this.selectedPosition === null) {
      this.searchResults = [];
      return;
    }

    if (
      !force && this.hasSearched && this.lastSearchCondition.lastName === this.lastName &&
      this.lastSearchCondition.firstName === this.firstName &&
      this.lastSearchCondition.position === this.selectedPosition
    ) {
      return;
    }

    this.lastSearchCondition = {
      lastName: this.lastName,
      firstName: this.firstName,
      position: this.selectedPosition
    };

    this.isSearching = true;
    this.attendanceSearchError = '';
    //this.selectedApprover = null;
    this.hasSearched = true;

    this.getSearchData();


    // TODO: API実装後に検索処理を追加
    //setTimeout(() => {
    //  this.searchResults = this.getMockSearchResults();
    //  this.isSearching = false;
    //}, 500);
  }

  isSelected(approver: Approver): boolean {
    return this.selectedApprovers.some(
      a => a.id === approver.id
    );
  }

  toggleApprover(approver: Approver) {

    const index = this.selectedApprovers.findIndex(
      a => a.id === approver.id
    );

    if (index >= 0) {

      this.selectedApprovers.splice(index, 1);

    } else {

      this.selectedApprovers.push(approver);

    }
  }

  onEnter(event: KeyboardEvent) {
    if (event.isComposing) return;
    (event.target as HTMLInputElement).blur();
  }

  private getSearchData() {

    // ぐるぐる表示
    this.searchResults = [];
    console.log(this.selectedPosition)
    Auth.currentSession().then(session => {
      const options = this.auth.createApiHeader(session);

      const isValidPosition = this.officialPositions.some(
        pos => pos.value === this.selectedPosition
      );

      console.log(this.userId1)


      options['body'] = {
        ...(this.data?.attendanceMode === true ? { action: 'search' } : {}),
        ...(this.data?.operationManagerMode === true ? { action: 'searchManagers', id: Number(this.eventId) } : {}),
        user_LastName: this.lastName,
        user_firstName: this.firstName,
        officialPosition: isValidPosition ? this.selectedPosition : null,
        excludedUserIds: [
          ...([this.userId1, this.userId2, this.userId3].filter(id => id != null)),
          ...this.extraExcludedIds
        ],
        event_id: this.eventId,
        document_type: this.documentType
      };
      this.commonUtil
        .apiPost(this.apiPath, options)
        .then(res => {
          this.searchResults = this.convertApprovers(res.data);
          // コンテンツのタグマスターデータを取得する
          this.commonUtil.debug().log(this.searchResults);
          this.isSearching = false;
        })
        .catch(err => {
          this.commonUtil.debug().log(err);
          if (err.message === Constant.msgLoginFailed) {
            this.commonUtil.showReloadDialog(this.auth);
          } else {
            this.isSearching = false;
            if (this.data?.attendanceMode || this.data?.operationManagerMode) {
              this.attendanceSearchError = err?.message || '検索できませんでした。もう一度検索してください。';
              this.hasSearched = false;
            } else {
              this.toastUtil.showErrorToast('', Constant.msgNetworkError, Constant.toastShowMiliSec);
            }
          }
        });
    });
  }

  private getData() {
    if (!this.commonUtil.isOnline()) {
      this.toastUtil.showErrorToast(Constant.empty, Constant.msgNetworkError, Constant.toastShowMiliSec);
      return;
    }
    this.showSpinner = true;
    Auth.currentSession().then(session => {
      const options = this.auth.createApiHeader(session);
      this.commonUtil.apiGet('/master', options).then(res => {
        if (!res.data) {
          // 削除済み
          this.toastUtil.showErrorToast(Constant.empty, Constant.msgDeleteAccountAlreadyError, Constant.toastShowMiliSec);
          this.dialogRef.close(true);
          return;
        }
        this.masters = res.data.master;
        this.setMasterData();
      })
      .catch(err => {
        this.commonUtil.debug().log(err);
        if (err.message === Constant.msgLoginFailed) {
          this.commonUtil.showReloadDialog(this.auth);
        } else {
          this.toastUtil.showErrorToast(Constant.empty, Constant.msgNetworkError, Constant.toastShowMiliSec);
          this.dialogRef.close();
        }
      });
    });
  }

  private lastSearchCondition = {
    lastName: '',
    firstName: '',
    position: null as number | null
  };

  private setMasterData() {
    // 役職
    this.officialPositions =
      ((this.masters[5] as any[]) || []).map(m => ({
        label: m.name,
        value: Number(m.id)
      }));
      this.showSpinner = false;
      if (this.data?.attendanceMode || this.data?.operationManagerMode) this.onSearch(true);
  }

  private convertApprovers(data: any[]): Approver[] {

    const typeMap: { [key: number]: string } = {
      1: '本部',
      2: '支部',
      3: 'エリア'
    };

    return data.map(user => {

      const affiliations = (user.organizations || []).map(org => {

        if (org.level === 0) {
          return org.path;
        }

        const prefix = typeMap[org.master_type] || '';
        return `${prefix} ${org.path}`.trim();
      });

      const concurrentAffiliations = (user.concurrent_organizations || []).map(org => {

        return `専門部 ${org.path}`.trim();
      });

      return {
        id: user.user_id,
        name: `${user.last_name} ${user.firstName}`,
        position: user.officialposition_name ?? '',
        positionId: user.officialposition == null ? undefined : Number(user.officialposition),
        affiliations: [
          ...affiliations,
          ...concurrentAffiliations
        ]
      };
    });
  }

  // 承認者選択
  //onSelectApprover(approver: Approver) {
  //  this.selectedApprover = approver;
  //}

  // 選択ボタン
  onSelect() {
    this.dialogRef.close(this.selectedApprovers);
  }

  // キャンセル
  onCancel() {
    this.dialogRef.close(false);
  }

  // モック検索結果
  private getMockSearchResults(): Approver[] {
    return [
      {
        id: '1',
        name: '姓姓 名名',
        position: '役職名役職名',
        affiliations: [
          '本部',
          '支部　北海道支部　札幌ブロック　営業部',
          '支部　北海道支部　札幌ブロック　札幌工場',
          '支部　北海道支部　函館ブロック',
          '支部　東北支部　営業部',
          '支部　北関東支部',
        ],
      },
      {
        id: '2',
        name: '姓姓 名名',
        position: '役職名役職名',
        affiliations: [
          '本部',
          '支部　北海道支部　札幌ブロック　営業部',
          '支部　北海道支部　札幌ブロック　札幌工場',
          '支部　北海道支部　函館ブロック',
          '支部　東北支部　営業部',
          '支部　北関東支部',
        ],
      },
    ];
  }
}
